import React from "react";
import "../../CSS/ai.css";
import { Link } from "react-router-dom";

function AIImageCreator() {

  return (
    <div className="ai-page">
      
      <section className="ai-hero">
        <div className="container">
          <div className="ai-hero-content">
            <h1>
              AI Image<br />
              <span>
                Creator & Editor
              </span>
            </h1>
            <p>
              Generate professional images, marketing creatives, product
              visuals, and custom artwork using AI.
            </p>
          </div>
        </div>
      </section>

      <section className="ai-service-info-section">
        <div className="container">
          <div className="ai-sections-heading text-center">
            <h2>
              AI-Powered Image Solutions
            </h2>
          </div>
          <div className="row g-4 mt-4">
            {/* Image Creation */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">
                <div className="ai-info-icon">
                  🎨
                </div>

                <h3>
                  AI Image Creation
                </h3>

                <p>
                  Create unique and professional images for websites,
                  applications, marketing campaigns, and digital platforms.
                </p>

              </div>
            </div>


            {/* Marketing */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  📢
                </div>

                <h3>
                  Marketing Creatives
                </h3>

                <p>
                  Develop attractive visual content for advertisements,
                  social media, promotions, and digital marketing campaigns.
                </p>

              </div>
            </div>


            {/* Product */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  📦
                </div>

                <h3>
                  Product Visuals
                </h3>

                <p>
                  Create professional product visuals and promotional
                  graphics to present your products effectively.
                </p>

              </div>
            </div>


            {/* Editing */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  ✨
                </div>

                <h3>
                  AI Image Editing
                </h3>

                <p>
                  Enhance and modify existing images with AI-assisted
                  editing, improvements, and creative adjustments.
                </p>

              </div>
            </div>


            {/* Social Media */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  📱
                </div>

                <h3>
                  Social Media Graphics
                </h3>

                <p>
                  Create engaging visual content suitable for social
                  media posts, campaigns, and online brand promotion.
                </p>

              </div>
            </div>


            {/* Custom */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-info-card">

                <div className="ai-info-icon">
                  ⚡
                </div>

                <h3>
                  Custom Image Solutions
                </h3>

                <p>
                  Customized AI-assisted image solutions based on your
                  business, branding, audience, and content requirements.
                </p>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA */}

      <section className="cta-section">
        <div className="container">
          <div className="cta-box">

            <div className="cta-content">
              <span className="ai-cta-label">
                START YOUR PROJECT
              </span>
              <h2>
                Need Professional Visual Content?
              </h2>

              <p>
                Tell us about your requirements and let us create
                the right visual solution for your business.
              </p>
            </div>

            <Link
              to="/contactus"
              className="cta-button" style={{ textDecoration: 'none' }}
            >
              Get In Touch
            </Link>

          </div>

        </div>

      </section>
    </div>
  );
}

export default AIImageCreator;